import { rankWith, uiTypeIs } from '@jsonforms/core'
import { withVanillaControlProps } from '@jsonforms/vanilla-renderers'

function SpacerRenderer() {
    return <div style={{ height: '0.5rem' }} />
}

export const SpacerTester = rankWith(3, uiTypeIs('Spacer'))

export default withVanillaControlProps(SpacerRenderer)
